import { handleActions } from 'redux-actions'
import types from '../actions/types'

export const defaultState = Object.freeze({
	authPending: true,
	showSignIn: false,
})

export default handleActions({
	[types.SIGN_IN_HIDE]: (state) => ({ ...state, showSignIn: false }),
	[types.SIGN_IN_SHOW]: (state) => ({ ...state, showSignIn: true }),
	[types.USER_UPDATED]: (state) => ({ ...state, authPending: false }),
}, defaultState)



// WEBPACK FOOTER //
// ./src/redux/reducers/app.js